import {
  mergeClasses,
  useArrowNavigationGroup,
} from "@fluentui/react-components";
import React from "react";
import { useFlexPanelStyles } from "./FlexPanel.styles";
import { FlexPanelProps } from "./FlexPanel.types";
/**
 * Container control used in various places of AppBar layout
 * @param props FlexPanel props
 * @param forwardRef Forwarded ref
 * @returns JSX.Element
 */
const FlexPanelRender: React.ForwardRefRenderFunction<
  HTMLDivElement,
  React.PropsWithChildren<FlexPanelProps>
> = (props, forwardRef) => {
  const styles = useFlexPanelStyles();
  const keyNavAttr = useArrowNavigationGroup({
    circular: true,
    axis: props.keyNavigationDirection,
    tabbable: props.tabbable,
    memorizeCurrent: props.memorizeCurrent,
  });
  const flexPanelStyles = React.useMemo(() => {
    return mergeClasses(
      styles.root,
      props.backgroundShadeClass,
      props.className,
      !props.horizontal && styles.column,
      props.wrap && styles.wrap,
      props.transparent && styles.transparent,
      props.fill && styles.fill,
      props.role === "navigation" && styles.resizable,
      props.mercuryDesignEnabled && styles.mercuryFlex
    );
  }, [props, styles]);
  return (
    <div
      ref={forwardRef}
      className={flexPanelStyles}
      role={props.role}
      aria-label={props["aria-label"]}
      {...(props.keyNavigationDirection && keyNavAttr)}
    >
      {props.children}
    </div>
  );
};
export const FlexPanel = React.forwardRef(FlexPanelRender);
